import React from 'react';

function SkeletonRow() {
  return (
    <tr style={{ borderBottom: '1px solid #F0F0EC' }}>
      {[200, 100, 120, 100, 80, 80, 120].map((w, i) => (
        <td key={i} style={{ padding: '14px 16px' }}>
          <div style={{
            width: w, height: 14, background: '#EDEDE9',
            borderRadius: 2, animation: 'pulse 1.4s ease-in-out infinite',
            animationDelay: `${i * 0.08}s`,
          }} />
        </td>
      ))}
    </tr>
  );
}

export default function SkeletonTable() {
  return (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr style={{ background: '#F5F5F2', borderBottom: '1px solid #E5E5E0' }}>
          {['Patient', 'Last visit', 'Treatment', 'Recall due', 'Days overdue', 'Status', 'Actions'].map(h => (
            <th key={h} style={{ padding: '10px 16px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: '#9A9A92', textTransform: 'uppercase', letterSpacing: '0.5px', fontFamily: "'JetBrains Mono', monospace", whiteSpace: 'nowrap' }}>
              {h}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: 5 }).map((_, i) => <SkeletonRow key={i} />)}
      </tbody>
    </table>
  );
}
